import { useCohort } from '@/components/user-context/helpers/cohorts';

import { LoggedInJpdExistingUser } from './existing-user';
import { LoggedInJpdNewUser } from './new-user';

export const LoggedInJpdFree = () => {
	const cohort = useCohort();
	if (cohort === 'new-user') {
		return <LoggedInJpdNewUser />;
	}

	return <LoggedInJpdExistingUser />;
};
